// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"9710b045","216":"827a0576","727":"c39c435a"}[chunkId] + ".chunk.js";
};